/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GeoBoundaryKind } from './GeoBoundaryKind';
import {
    GeoBoundaryKindFromJSON,
    GeoBoundaryKindFromJSONTyped,
    GeoBoundaryKindToJSON,
    GeoBoundaryKindToJSONTyped,
} from './GeoBoundaryKind';

/**
 * 
 * @export
 * @interface GeoBoundarySummary
 */
export interface GeoBoundarySummary {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    kind: GeoBoundaryKind;
    /**
     * 
     */
    geoid: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    state_id?: string;
}



/**
 * Check if a given object implements the GeoBoundarySummary interface.
 */
export function instanceOfGeoBoundarySummary(value: object): value is GeoBoundarySummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('geoid' in value) || value['geoid'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function GeoBoundarySummaryFromJSON(json: any): GeoBoundarySummary {
    return GeoBoundarySummaryFromJSONTyped(json, false);
}

export function GeoBoundarySummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeoBoundarySummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'kind': GeoBoundaryKindFromJSON(json['kind']),
        'geoid': json['geoid'],
        'name': json['name'],
        'state_id': json['state_id'] == null ? undefined : json['state_id'],
    };
}

export function GeoBoundarySummaryToJSON(json: any): GeoBoundarySummary {
    return GeoBoundarySummaryToJSONTyped(json, false);
}

export function GeoBoundarySummaryToJSONTyped(value?: GeoBoundarySummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'kind': GeoBoundaryKindToJSON(value['kind']),
        'geoid': value['geoid'],
        'name': value['name'],
        'state_id': value['state_id'],
    };
}

